/* eslint-disable no-unused-vars */
import React from 'react'

export default function News() {
  return (
    <div>News</div>
  )
}
